/** @jsxImportSource theme-ui */
import React from 'react';
import { jsx } from 'theme-ui';
import { Link } from 'gatsby';
import { Link as ExternalLink, Box } from '@theme-ui/components';
import { Button } from '@greythr/shared-components';

export const CTALink = ({ name, link, align, id }) => {
	const isExternalLink = link.startsWith('http');

	return (
		<Box sx={{ textAlign: align }}>
			{isExternalLink ? (
				<ExternalLink href={link} target='_blank'>
					<Button size="large" variant="filled" id={id}>
						{name}
					</Button>
				</ExternalLink>
			) : (
				<Link to={link}>
					<Button size="large" variant="filled" id={id}>
						{name}
					</Button>
				</Link>
			)}
		</Box>
	);
};

const CTA = ({ code, blogID, ctaDirectory }) => {
	const cta = ctaDirectory.find((ele) => ele.code === code);
	const isExternalLink = cta && cta.url.startsWith('http');
	const btnColor = cta?.backgroundColor || 'primary';
	const cleanedBlogID = blogID.replace(/\D+/g, '');
	const btnID = `${code}_${cleanedBlogID}`;

	const sx = {
		my: 3,
		bg: btnColor,
		borderRadius: 5,
		'&:hover': {
			bg: btnColor,
		},
	};

	if (cta) {
		return (
			<>
				{isExternalLink ? (
					<ExternalLink href={cta.url} target='_blank'>
						<Button sx={sx} id={btnID}>
							{cta.caption}
						</Button>
					</ExternalLink>
				) : (
					<Link to={cta.url}>
						<Button sx={sx} id={btnID}>
							{cta.caption}
						</Button>
					</Link>
				)}
			</>
		);
	}
	return null;
};

export default CTA;
